// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tbl_search th[data-v-08ec20ac] {vertical-align: top;}\n.content_box[data-v-08ec20ac] {border-color: #C7DAFF;}\n", ""]);
// Exports
module.exports = exports;
